module.exports = __webpack_public_path__ + "media/images/help/i-step4-extra-79f8b7025e870667519d6502ae18fb2d.png";